import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, useLocation } from "react-router-dom";
import axios from "axios";
import { initLenis } from "@/lib/scroll";
import { AuthContext } from "@/lib/auth";
import AuthCallback from "@/components/AuthCallback";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Intro } from "@/components/Intro";
import { Storia } from "@/components/Storia";
import { Architettura } from "@/components/Architettura";
import { Affreschi } from "@/components/Affreschi";
import { Opere } from "@/components/Opere";
import { Oggi } from "@/components/Oggi";
import { Galleria } from "@/components/Galleria";
import { Fonti } from "@/components/Fonti";
import { Footer } from "@/components/Footer";
import { BackToTop } from "@/components/BackToTop";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Site = () => (
  <div className="App bg-ivory text-espresso antialiased">
    <Navbar />
    <main>
      <Hero />
      <Intro />
      <Marquee />
      <Storia />
      <Architettura />
      <Affreschi />
      <Opere />
      <Oggi />
      <Galleria />
      <Fonti />
    </main>
    <Footer />
    <BackToTop />
  </div>
);

function AppShell() {
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    initLenis();
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setChecking(false);
      return;
    }
    let alive = true;
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then((res) => {
        if (alive) setUser(res.data);
      })
      .catch(() => {})
      .finally(() => {
        if (alive) setChecking(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <AuthContext.Provider value={{ user, checking, setUser }}>
      {location.hash?.includes("session_id=") ? <AuthCallback /> : <Site />}
    </AuthContext.Provider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
